import React from 'react';
import qs from 'qs';
import PropTypes from 'prop-types';
import Helmet from 'react-helmet';
import Card from 'react-toolbox/lib/card';
import Logo from '../Logo';
import CardBody from '../CardBody';
import LeftPane from '../layout/LeftPane';
import ForgotPasswordForm from '../ForgotPasswordForm';
import styles from '../../components/pages/LoginPage.scss';

const propTypes = {
  email: PropTypes.string,
};

const ForgotPasswordPage = props => {
  const query = qs.parse(window.location.search.replace('?', ''));
  // if email is in query string, use it, else go with value in props
  const email = query.email || props.email;
  return (
    <LeftPane className="col-xs-12 col-sm-6">
      <Card className={styles.loginFormCard}>
        <Helmet title="Reset Password" />
        <CardBody>
          <Logo />
          <div className="text--preamble text-size-md mb-2">
            <h2>Reset your password</h2>
          </div>
          <ForgotPasswordForm email={email} />
        </CardBody>
      </Card>
    </LeftPane>
  );
};

ForgotPasswordPage.propTypes = propTypes;

export default ForgotPasswordPage;



// WEBPACK FOOTER //
// ./src/client/src/components/pages/ForgotPasswordPage.js